import React from "react";
import { Typography } from "antd";
import { motion } from "framer-motion";
import "./AboutPage.css";

const { Title, Paragraph } = Typography;

const services = [
  { title: "Website Design", desc: "Modern, responsive websites built for performance." },
  { title: "Logo Design", desc: "Memorable brand identities that connect." },
  { title: "Template Design", desc: "Customizable, professional design templates." },
  { title: "Invitation Design", desc: "Personalized invitation designs for any occasion." },
];

const glowingDots = Array.from({ length: 20 }, (_, i) => (
  <div key={i} className={`glow-dot dot-${i}`} />
));

const About = () => {
  return (
    <div className="about-tech-wrapper">

      {/* 3D Rings and Dots */}
      <div className="wireframe-ring"></div>
      <div className="wireframe-ring"></div>
      <div className="wireframe-ring"></div>
      {glowingDots}

      <div className="about-container">

        {/* Welcome About Section */}
        <div className="about-top-section">
          <motion.div
            className="about-text"
            initial={{ opacity: 0, x: -50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          >
            <Title className="about-title">About Us</Title>
            <Paragraph className="about-desc">
              Where imagination meets innovation and design becomes an experience. Born from the vision of two passionate friends with a shared love for creativity and technology, our journey began not in a boardroom, but in late-night brainstorming sessions and sketches on napkins — all driven by a belief in purposeful design.
            </Paragraph>
          </motion.div>

          <motion.img
            src={require("../Asset/about.png")}
            alt="Creovate"
            className="about-image"
            initial={{ opacity: 0, x: 50 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 1 }}
          />
        </div>

        {/* Services Grid */}
        <div className="service-grid">
          {services.map((service, index) => (
            <motion.div
              key={index}
              className="service-card"
              whileHover={{ scale: 1.05 }}
            >
              <h3>{service.title}</h3>
              <p>{service.desc}</p>
            </motion.div>
          ))}
        </div>

        {/* Mission, Vision, Story with Side Image */}
        <div className="mission-vision-section">
          <div className="info-card-grid">
            <motion.div className="info-card" whileHover={{ scale: 1.05 }}>
              <h3>Our Mission</h3>
              <p>Empowering businesses through innovative, tech-driven design that leaves a lasting impression.</p>
            </motion.div>

            <motion.div className="info-card" whileHover={{ scale: 1.05 }}>
              <h3>Our Vision</h3>
              <p>To be a global design partner that merges creativity with emerging technologies to transform brands.</p>
            </motion.div>

            <motion.div className="info-card" whileHover={{ scale: 1.05 }}>
              <h3>Our Story</h3>
              <p>Born from late-night brainstorming, Creovate is the dream of two friends blending passion, technology, and creativity.</p>
            </motion.div>
          </div>

          <motion.img
            src={require("../Asset/about1.png")}
            alt="Second Visual"
            className="second-image"
            initial={{ opacity: 0, y: 50 }}
            animate={{ opacity: 1, y: 0 }}
            transition={{ duration: 1 }}
          />
        </div>

      </div>
    </div>
  );
};

export default About;
